module.exports = __webpack_public_path__ + "fonts/Roboto-Light.ed4b08d.woff2";